import { filterUndefineds } from '@olivierpascal/helpers';
import { normalizeString, } from './normalizeString';
const defaultOptions = {
    limit: 100,
    matchFrom: 'any',
};
export const createFilter = (userOptions) => {
    const options = {
        ...defaultOptions,
        ...userOptions,
    };
    const { limit, matchFrom, getSearchableText } = options;
    return (items, query) => {
        const normalizedQuery = normalizeString(query, options);
        const filteredOptions = normalizedQuery
            ? items.filter((option) => {
                const candidate = getSearchableText(option);
                const candidates = Array.isArray(candidate) ? candidate : [candidate];
                const normalizedCandidates = filterUndefineds(candidates).map((candidate) => normalizeString(candidate));
                return normalizedCandidates.some((normalizedCandidate) => normalizedCandidate
                    ? matchFrom === 'start'
                        ? normalizedCandidate.startsWith(normalizedQuery)
                        : normalizedCandidate.includes(normalizedQuery)
                    : false);
            })
            : items;
        return typeof limit === 'number'
            ? filteredOptions.slice(0, limit)
            : filteredOptions;
    };
};
